import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 葡萄牙语巴西
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Todos os direitos reservados',
    },
    auth: {
        login: 'Entrar',
        username: 'Nome de usuário',
        username_placeholder: 'Digite seu nome de usuário',
        password: 'Senha',
        password_placeholder: 'Digite sua senha',
        code: 'Código de verificação',
        code_placeholder: 'Digite o código de verificação',
        logout: 'Sair',
        logout_success: 'Saiu com sucesso',
        day: 'dia',
        password_expiration: 'A validade da senha expirou – é necessário alterá-la',
        expire: 'Dias restantes até a expiração da senha',
        conseils:
            'Deve conter letras maiúsculas, minúsculas, números e caracteres especiais ({msg}). O comprimento da senha deve ter entre 8 e 16 caracteres.',
        brand_Selection: 'Seleção de marca',
        unread_notices: 'Avisos não lidos',
        new_cases: 'Novos casos',
        unanswered_cases: 'Casos sem resposta',
        overdue_cases: 'Casos vencidos',
    },
    button: {
        query: 'Consultar',
        editing_position: 'Editar cargo',
        show_theme_editor: 'Mostrar/ocultar editor de tema',
        change_password: 'Alterar senha',
        old_password: 'Senha antiga',
        new_password: 'Nova senha',
        confirm_password: 'Confirmar senha',
        button: 'Botão',
        about: 'Sobre',
        back: 'Voltar',
        go: 'OK',
        home: 'Página inicial',
        confirm: 'Confirmar',
        modify: 'Modificar',
        edit: 'Editar',
        new: 'Novo',
        cancel: 'Cancelar',
        close: 'Fechar',
        search: 'Pesquisar',
        reset: 'Redefinir',
        delete: 'Excluir',
        add: 'Adicionar',
        collapse: 'Recolher',
        expand: 'Expandir',
        download_template: 'Baixar modelo',
        batch_import: 'Importação em lote',
        import: 'Importar',
        export: 'Exportar',
        export_fail: 'Falha na importação',
        detailed: 'Detalhado',
        details: 'Detalhes',
        download: 'Baixar',
        toView: 'Visualizar',
        toViews: 'Ver imagens',
        uploadAttachments: 'Enviar anexos',
        selectFile: 'Selecione o arquivo',
        fillingInstructions: 'Instruções de preenchimento',
        release: 'Publicar',
        release_recall: 'Retirar publicação',
        save: 'Salvar',
        send: 'Enviar',
        tips: 'Dicas',
        send_back: 'Devolver',
        examine: 'Examinar',
        void: 'Anular',
        more: 'Mais',
        refresh: 'Atualizar',
        selects: 'Selecionar',
        serial_number: 'Número de série',
        upload_progress: 'Progresso do envio',
        invalid: 'Inválido',
        daily_record: 'Registro diário',
        operation_type: 'Tipo de operação',
        field_name: 'Nome do campo',
        edit_role: 'Editar função',
        user_role: 'Selecione uma função',
        assignment_role: 'Função',
        post: 'Cargo',
        sending: 'Enviando...',
        reset_password: 'Redefinir senha',
        display_or_not: 'Exibir ou não',
        document: 'Documento',
        specificTemplates: 'Modelos específicos',
        transferOrder: 'Transferir pedido',
        forwarding: 'Encaminhar',
        one_click_notification: 'Notificação com um clique',
        english_export: 'Exportar em inglês',
        oneclick_download: 'Download com um clique',
        passwordmsga:
            'Deve conter letras maiúsculas, minúsculas, números e caracteres especiais (@\\$!_~\\&*)',
        passwordmsgb: 'O comprimento da senha deve ter entre 8 e 16 caracteres',
        passwordmsgc: 'Não pode ser igual a nenhuma das seis senhas anteriores',
        export_file_list: 'Lista de arquivos exportados',
        personal_center: 'Centro pessoal',
        upload_list: 'Lista de uploads',
        clear_completed: 'Limpar concluídos',
    },
    radio: {
        enabled: 'Habilitado',
        disabled: 'Desabilitado',
        catalogue: 'Catálogo',
        individual: 'Individual',
        all: 'Todos',
        yes: 'Sim',
        no: 'Não',
    },
    dropdown: {
        close_others: 'Fechar outros',
        close_right: 'Fechar à direita',
        close_left: 'Fechar à esquerda',
    },
    table: {
        action: 'Ação',
        explain: 'Explicação',
        fileName: 'Nome do arquivo',
        size: 'Tamanho (MB)',
        uploader: 'Enviado por',
        uploadTime: 'Data de envio',
        system: 'Sistema',
        caption: 'Legenda',
        categorization: 'Categorização',
        link: 'Link',
        forwarding_time: 'Data de encaminhamento',
        forwarder: 'Encaminhado por',
        send_to: 'Enviar para',
        mode: 'Modo',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Página ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) =>
            `Total de ${named('number')} registros`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Total de ${named('number')} veículos`,
    },
    confirm: {
        confirm_deletion: 'Confirmar exclusão?',
        confirm_void: 'Confirmar anulação?',
        confirm_release: 'Confirmar publicação?',
        ack: 'Confirmar',
        cancel: 'Cancelar',
        non_records: 'Selecione pelo menos um registro',
    },
    request: {
        failed_placeholder: 'Falha na solicitação – erro do servidor',
        success_placeholder: 'Solicitação bem-sucedida',
        auth: {
            login_success: 'Login realizado com sucesso',
        },
        error: {
            '404': 'Rota da solicitação não encontrada',
            '403': 'Permissões insuficientes',
        },
    },
    page: {
        global: {
            page_search: 'Pesquisar na página',
        },
        error: {
            not_found: 'Página não encontrada',
            not_found_des: 'Nada por aqui',
            auth_failed: 'Permissões insuficientes',
            auth_failed_des: 'Esta página é proibida',
            file_format_error: 'Formato de arquivo inválido!',
            preview_failed: 'Falha na visualização! O arquivo está corrompido!',
        },
        homepage: {
            homepage: homepage.homepage.ptBR,
        },
        system: {
            menu: system.menu.ptBR,
            dict: system.dict.ptBR,
            dept: system.dept.ptBR,
            role: system.role.ptBR,
            user: system.user.ptBR,
        },
        info: {
            announcement: Info.announcement.announcement.ptBR,
            document: Info.document.document.ptBR,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.ptBR,
                recallActivity: tech.quality.recallActivity.ptBR,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.ptBR,
            },
            management: {
                inquiryOd: tech.management.inquiry.ptBR,
                permission: tech.management.permission.ptBR,
                onSiteSupportHq: tech.management.onSiteSupport.ptBR,
                progHistoryHq: tech.management.progHistory.ptBR,
                salesRecordHq: tech.management.salesRecord.ptBR,
                vehicleInfoHq: tech.management.vehicleInfo.ptBR,
                claimHq: tech.management.claim.ptBR,
                filterHq: tech.management.filter.ptBR,
                newCarlssue: tech.management.newCarIssue.ptBR,
                newCarDefinition: tech.management.newCarDefinition.ptBR,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.ptBR,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.ptBR,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.ptBR,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.ptBR,
        },
        statistics: statistics.inquiryStatistics.ptBR,
        systemClassifyA: statistics.systemClassifyA.ptBR,
        systemClassifyB: statistics.systemClassifyB.ptBR,
        engineerStatistics: statistics.engineerStatistics.ptBR,
        defectivePart: statistics.defectivePart.ptBR,
        replyInquiryStatistics: statistics.replyInquiryStatistics.ptBR,
        passRateStatistics: statistics.passRateStatistics.ptBR,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.ptBR,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.ptBR,
        customsClearance135Rate: statistics.customsClearance135Rate.ptBR,
        accumulatedClosureRate: statistics.accumulatedClosureRate.ptBR,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.ptBR,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.ptBR,
    },
    validation: {
        common: {
            required: 'Este campo é obrigatório',
            numeric: 'Deve ser um número inteiro',
            decimal: 'Deve ser um número',
            positive_interger: 'Deve ser um número inteiro positivo',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Máximo de ${named('number')} dígitos`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Não pode exceder ${named('number')} caracteres`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Limite máximo de caracteres excedido (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Deve ter pelo menos ${named('number')} caracteres`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Deve ter exatamente ${named('number')} caracteres`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Não pode ser maior que ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Não pode ser menor que ${named('number')}`,
            up_to_2_decimal_places: 'Máximo de 2 casas decimais',
            retain_up: 'Máximo de 10 dígitos antes da vírgula e 2 após',
            retain_ups: 'Máximo de 11 dígitos antes da vírgula e 4 após',
            input_number: 'Insira apenas algarismos arábicos',
            only_number_a: 'Apenas letras ou números permitidos',
            translate: 'Apenas letras permitidas',
            positive_integer: 'Preencha pelo menos um campo',
            at_least_one: 'Preencha pelo menos um',
        },
        tip: {
            incomplete_information: 'Informações incompletas',
        },
    },
    import: {
        template_file: 'Arquivo de modelo',
        browse: 'Procurar',
        download_template: 'Baixar modelo',
        no_file_selected: 'Nenhum arquivo selecionado',
        incorrect_file_type: 'Tipo de arquivo incorreto',
        exceed: 'Limite excedido',
        upload_success: 'Upload realizado com sucesso',
        upload_fail: 'Falha no upload',
        again_upload:
            'Somente imagens nos formatos jpg, png, bmp ou gif podem ser enviadas. Tente novamente.',
        attachmentUpload: 'Upload de anexos',
        otherAttachmentUpload: 'Upload de outros anexos',
        supportedFormats: 'Formatos suportados',
        preview: 'Visualizar',
    },
    export: {
        noDataToExport: 'Nenhum dado para exportar',
    },
    select: {
        all: 'Todos',
    },
    checkbox: {
        select_all: 'Selecionar tudo',
    },
    dialog: {
        error_message: 'Mensagem de erro',
        one_year: 'É possível exportar no máximo um ano de dados por vez',
    },
    ymd: {
        year: 'ano',
        month: 'mês',
        day: 'dia',
        week: 'semana',
        january: 'Janeiro',
        february: 'Fevereiro',
        march: 'Março',
        april: 'Abril',
        may: 'Maio',
        june: 'Junho',
        july: 'Julho',
        august: 'Agosto',
        september: 'Setembro',
        october: 'Outubro',
        november: 'Novembro',
        december: 'Dezembro',
    },
};
